import { uid } from '../utils/uid.js';
/**
 * @description Creates a base client with the given transport.
 */
export function createClient({ chain, key = 'base', name = 'Base Client', pollingInterval = 4000, transport, type = 'base', }) {
    const { config, request, value } = transport({ chain, pollingInterval });
    return {
        chain: chain,
        key,
        name,
        pollingInterval,
        request: request,
        transport: { ...config, ...value },
        type,
        uid: uid(),
    };
}
//# sourceMappingURL=createClient.js.map